import { render, staticRenderFns } from "./ReferralBenefits.vue?vue&type=template&id=2a29087e&scoped=true&"
import script from "./ReferralBenefits.vue?vue&type=script&lang=js&"
export * from "./ReferralBenefits.vue?vue&type=script&lang=js&"
import style0 from "./ReferralBenefits.vue?vue&type=style&index=0&id=2a29087e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a29087e",
  null
  
)

export default component.exports